import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Volumes/extdisk/project/web/sprunki-rule/node_modules/next/dist/client/link.js");
